import {
  AddCardSoftwaremanagementSoftwareSetupCardholderDataInput,
  BankingCardLimitPeriodEnum,
  SoftwareManagementAddCardDocument,
  SoftwareManagementAddCardMutation,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateCard = () => {
  const [createCard, { loading }] = useMutation(SoftwareManagementAddCardDocument, {
    extractorFn: (data: SoftwareManagementAddCardMutation) =>
      data.softwareManagementMutations.addCardSoftwaremanagementSoftwareSetup,
  })

  const companyId = useCurrentSession().company.id

  return {
    createCard(
      softwareSetupId: string,
      amountLimitCents: number,
      period: BankingCardLimitPeriodEnum,
      employeeId: string,
      cardholderData?: AddCardSoftwaremanagementSoftwareSetupCardholderDataInput
    ) {
      return createCard({
        variables: {
          companyId,
          softwareSetupId: softwareSetupId,
          amountLimitCents: amountLimitCents,
          cardholderData: cardholderData,
          employeeId: employeeId,
          limitPeriod: period,
        },
      })
    },
    loading,
  }
}
